import { Input, InputProps } from "@chakra-ui/react";
import React from "react";

export interface UiInputProps extends InputProps {}

export function UiInput({ ...rest }: UiInputProps) {
  return <Input {...rest} />;
}
